import { Box, LinearProgress, SxProps, Theme } from '@mui/material';
import { useMemo } from 'react';
import { useNameChangeReviewTableInstance } from './tables/name-change-review-table-instance';
import { useNameChangeApprovalWorkflowListState } from 'shared/contexts/name-change-approval-workflow-filter-context';
import { NameChangeReviewTable } from './tables/name-change-review-table';

const mainContentStyles: SxProps<Theme> = {
  padding: 2,
};

const containerStyles: SxProps<Theme> = {
  paddingTop: 2,
};

export function NameChangeReview() {
  const {
    nameChanges,
    nameChangeApprovalWorkflowTableState,
    setNameChangeApprovalWorkflowTableState,
    isFetching,
    isLoading,
  } = useNameChangeApprovalWorkflowListState();

  const nameChangeData = nameChanges?.nameChanges;
  const nameChangeTableData = useMemo(
    () =>
      (nameChangeData || []).map(nameChangeData => ({
        id: nameChangeData.id,
        currentCustomerName: nameChangeData.currentCustomerName,
        newCustomerName: nameChangeData.newCustomerName,
        brand: nameChangeData.brand,
        channel: nameChangeData.channel,
        approvalStatus: nameChangeData.approvalStatus,
        customerTier: nameChangeData.customerTier,
        modifiedBy: nameChangeData.modifiedBy,
        modifiedDate: nameChangeData.modifiedDate,
        approvedBy: nameChangeData.approvedBy,
        approvedDate: nameChangeData.approvedDate,
      })),
    [nameChangeData]
  );

  const nameChangeReviewTableInstance = useNameChangeReviewTableInstance(
    nameChangeTableData,
    nameChanges?.totalCount || 0,
    nameChangeApprovalWorkflowTableState.tableState
  );
  const loading = isFetching || isLoading;

  return (
    <>
      <Box sx={mainContentStyles}>
        <Box sx={containerStyles}>
          {loading && <LinearProgress color='secondary' />}
          <NameChangeReviewTable
            instance={nameChangeReviewTableInstance}
            setNameChangeApprovalWorkflowTableState={setNameChangeApprovalWorkflowTableState}
            totalCount={!!nameChanges?.totalCount ? nameChanges.totalCount : 0}
          />
        </Box>
      </Box>
    </>
  );
}
